export default __webpack_public_path__ + "static/media/card-m-press@2x.332974c9.png";